// Factura o boleta, en Perú, sin mirar la serie del número.
//
// El terminal decidía si un documento era boleta o factura por el **prefijo** de
// su número: `BP`/`BPR` boleta, `FP`/`FPR` factura. Eran las series de antes.
// Las de hoy son otras --`B4B1`, `BAG1`, `B002` para boletas, `F4F1` para
// facturas--, y una boleta `B4B1-0000049` caía en «factura»: la nota de crédito
// viajaba a Business Central con `SUNAT_Document_Ref = 01` y el tiquete imprimía
// «Doc. Referencia: FACTURA». Medido en Perú TEST el 27/10/2026.
//
// La serie la configura cada caja y puede cambiar cuando quiera: no es un dato
// del documento. Lo que sí lo es, por orden:
//
//  1. `Tipo_SUNAT`: el `SUNAT_Document` que publica Business Central para el
//     documento (01 factura, 03 boleta). Lo guarda «Traer históricos».
//  2. `Document_Type`: el terminal guarda la boleta que hace él mismo como
//     «Boleta», y la factura como «Invoice».
//  3. El prefijo de las series de antes, sólo de respaldo para documentos viejos
//     que no traigan ninguno de los dos.
//
// `SUNAT_Document` se acepta sólo si dice exactamente 01 o 03. En los históricos
// es el comprobante que publica Business Central, y en el documento del terminal
// ya enviado, el que se mandó (03 boleta, 07 nota de crédito). Antes de enviarse,
// ese mismo nombre guarda el tipo de identidad del cliente --1 DNI, 6 RUC, de un
// dígito--, que nunca coincide con esos dos.

export const FACTURA = "01";
export const BOLETA = "03";

/**
 * @param {object} documento Un documento de venta (factura o boleta).
 * @returns {"01"|"03"|null} El tipo SUNAT, o null si no hay forma de saberlo.
 */
export const tipoSunatDelDocumento = (documento) => {
  if (!documento) return null;

  const deBC = String(documento.Tipo_SUNAT ?? "").trim();
  if (deBC === FACTURA || deBC === BOLETA) return deBC;

  const comprobante = String(documento.SUNAT_Document ?? "").trim();
  if (comprobante === FACTURA || comprobante === BOLETA) return comprobante;

  if (documento.Document_Type === "Boleta") return BOLETA;

  const no = String(documento.No ?? "").trim().toUpperCase();
  if (no.startsWith("BP")) return BOLETA;
  if (no.startsWith("FP")) return FACTURA;

  if (documento.Document_Type === "Invoice") return FACTURA;
  return null;
};

/** Cómo se nombra el tipo en el tiquete. */
export const nombreDelTipoSunat = (tipo) =>
  tipo === BOLETA ? "BOLETA DE VENTA" : tipo === FACTURA ? "FACTURA" : null;
